import httpClient from '../../utilities/http/http-client';

const endPoint = '/v1/web/admin/destination/destination';

export default {
  getData(params = {}) {
    return httpClient.post(endPoint, params);
  },
  saveData(params = {}) {
    return httpClient.post(endPoint + '/create', params);
  },
  getDataDetail(params = {}) {
    return httpClient.post(endPoint + '/detail', params);
  },
  updateData(params = {}) {
    return httpClient.post(endPoint + '/update', params);
  },
  deleteData(params = {}) {
    return httpClient.post(endPoint + '/delete', params);
  },
};
